export default __webpack_public_path__ + "static/media/totalBatches.73908364.svg";